var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "spa-booking-details-form form",
      on: {
        submit: function ($event) {
          $event.preventDefault()
        },
      },
    },
    [
      _c("fieldset", { staticClass: "flex-grid-3-col gutter-lg py-0" }, [
        _c("legend", { staticClass: "sr-only" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.tc("spaSoft.step1.guestTimeDateSelection.title")) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input dropdown" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.numberOfGuests,
                  expression: "numberOfGuests",
                },
              ],
              ref: "guestsInput",
              staticClass: "req",
              attrs: {
                id: "numberOfGuests",
                name: "numberOfGuests",
                "data-val": "true",
                "data-field-type": "DropdownList",
                "aria-required": "true",
                "aria-invalid": !_vm.numberOfGuests,
              },
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.numberOfGuests = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
              },
            },
            _vm._l(_vm.maxGuestsBooking, function (guest) {
              return _c("option", { key: guest, domProps: { value: guest } }, [
                _vm._v("\n          " + _vm._s(guest) + "\n        "),
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "req floating select-label",
              attrs: { for: "numberOfGuests" },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.tc(
                      "spaSoft.step1.guestTimeDateSelection.numberOfGuestsLabel"
                    )
                  ) +
                  "\n      "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "input" },
          [
            _c("date-field-input", {
              ref: "dateFieldInput",
              attrs: {
                lang: _vm.daysAndMonths,
                "emit-event": true,
                "min-date": _vm.todaysDate,
                "max-date": _vm.oneYearLaterDate,
              },
              on: { dateChange: _vm.handleInputDateChange },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var toggleCalendar = ref.toggleCalendar
                    var onChange = ref.onChange
                    return [
                      _c("input", {
                        ref: "dateInput",
                        staticClass: "req",
                        attrs: {
                          id: "date",
                          type: "date",
                          name: "date",
                          max: _vm.oneYearLaterDate,
                          "data-val": "true",
                          "data-field-type": "DateField",
                          "aria-required": "true",
                          "aria-invalid": !_vm.selectedDate,
                        },
                        domProps: { value: _vm.selectedDate },
                        on: { change: _vm.handleInputDateChange },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        { staticClass: "req floating", attrs: { for: "date" } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.tc(
                                  "spaSoft.step1.guestTimeDateSelection.dateLabel"
                                )
                              ) +
                              "\n\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("button", {
                        staticClass: "icon-calendar",
                        attrs: {
                          type: "button",
                          "aria-label": _vm.tc(
                            "spaSoft.step1.guestTimeDateSelection.ariaLabelCalendarButton"
                          ),
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return toggleCalendar($event)
                          },
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "input dropdown" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.preferredStartTime,
                  expression: "preferredStartTime",
                  modifiers: { number: true },
                },
              ],
              staticClass: "req",
              attrs: {
                id: "preferredStartTime",
                name: "preferredStartTime",
                "data-field-type": "DropdownList",
                "aria-required": "true",
                "aria-invalid": !_vm.preferredStartTime,
              },
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return _vm._n(val)
                    })
                  _vm.preferredStartTime = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
              },
            },
            _vm._l(_vm.preferredStartTimeOptions, function (time) {
              return _c(
                "option",
                { key: time.value, domProps: { value: time.value } },
                [_vm._v("\n          " + _vm._s(time.label) + "\n        ")]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "floating select-label",
              attrs: { for: "preferredStartTime" },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.tc(
                      "spaSoft.step1.guestTimeDateSelection.preferredStartTimeLabel"
                    )
                  ) +
                  "\n      "
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("date-change-notification-modal", {
        ref: "dateChangeNotificationModal",
        on: { "update-date": _vm.updateDate },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }